import React, { useEffect, useState } from "react";
import { AutoComplete, Form, Input } from "antd";
import axios from "axios";
import { CostType } from "../../@types/cost";
import { useParams } from "react-router-dom";

interface EditableCellProps extends React.HTMLAttributes<HTMLElement> {
  editing: boolean;
  dataIndex: string;
  title: any;
  inputType: "number" | "text";
  record: CostType;
  index: number;
  test: Function;
  children: React.ReactNode;
}

type TypeListNameRoom = {
  value: string;
};

const EditableCellAll: React.FC<EditableCellProps> = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  test,
  ...restProps
}) => {
  const [listNameRoom, setListNameRoom] = useState<TypeListNameRoom[]>([]);
  const { ownerId } = useParams();
  const [optionsAutoComplete, setOptionsAutoComplete] = useState<
    TypeListNameRoom[]
  >([]);

  const onSearchAutoComplete = (searchText: string) => {
    if (!searchText) {
      const rooms = listNameRoom.map(({ value }) => {
        return { value };
      });
      return setOptionsAutoComplete(rooms);
    }

    const filteredRooms = listNameRoom.filter(
      ({ value }) => value.indexOf(searchText) >= 0
    );
    setOptionsAutoComplete(filteredRooms);
  };

  const fetchListNameRoom = async () => {
    try {
      const res = await axios
        .get(`/apartments/all-rooms`, {
          params: ownerId ? { ownerId } : {},
        })
        .then((res) => res.data);
      const listNameRoom: TypeListNameRoom[] = res.map((room: string) => ({
        value: room,
      }));
      setListNameRoom(listNameRoom);
      const rooms = listNameRoom.map(({ value }) => {
        return { value };
      });
      return setOptionsAutoComplete(rooms);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (dataIndex === "RoomName") {
      fetchListNameRoom();
    }
  }, []);

  const inputNode =
    dataIndex === "RoomName" ? (
      <AutoComplete
        options={optionsAutoComplete}
        style={{
          width: "100%",
        }}
        onSearch={onSearchAutoComplete}
        placeholder="input here"
        children={<Input type="search" />}
      />
    ) : dataIndex === "DateFrom" ||
      dataIndex === "DateTo" ||
      dataIndex === "SentON" ? (
      <Input type="date" />
    ) : dataIndex === "ApartmentTotal" ||
      dataIndex === "CostTotal" ||
      dataIndex === "parkingTotal" ||
      dataIndex === "FinalTotal" ? (
      <Input type="number" onChange={() => test()} />
    ) : (
      <Input />
    );

  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{ margin: 0 }}
          rules={[
            {
              required: true,
              message: `Please Input ${dataIndex}!`,
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

export default EditableCellAll;
